import client from '../httpClient';

const lineGetIdApi = (customerId) => {
  return client.get(`/line-rooms/customers/${customerId}`);
};

export default lineGetIdApi;
